import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    component: () => import("../views/About.vue"),
  },
  {
    path: "/mission",
    name: "Mission",
    component: () => import("../views/Mission.vue"),
  },
  {
    path: "/contact",
    name: "Contact",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Contact.vue"),
  },
  {
    path: "/recruitment",
    name: "Recruitment",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Recruitment.vue"),
  },
  {
    path: "/publishing",
    name: "Publishing",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Publishing.vue"),
  },
];
const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
